import type {
  RyftPaymentInitiateRequestType,
  RyftPaymentUpdatePathParametersType,
  RyftPaymentUpdateRequestType,
  RyftOrderPaymentInitiateResponseType,
} from "@sellar-io/api-v2/types";
import { createContext, RefObject } from "react";
import type { ErrorResult, SuccessResult } from "./types";
import {
  RyftCardFormInstance,
  RyftPaymentAttemptResponse,
  RyftValidationChangeEvent,
} from "@ryftpay/react";

export type SafeReturnType<T> = SuccessResult<T> | ErrorResult<Error>;

export type RyftCardPaymentContextType = {
  ryftAccountId: string | null;
  isInitiatingPaymentSession: boolean;
  isUpdatingPaymentSession: boolean;
  isAttemptingPayment: boolean;
  ryftPublicKey: string;
  paymentSessionId: string | null;
  clientSecret: string | null;
  paymentSessionStatus: RyftOrderPaymentInitiateResponseType["status"] | null;
  cardFormValidationEvent: RyftValidationChangeEvent | null;
  cardFormInstanceRef: RefObject<RyftCardFormInstance | null>;
  setCardFormValidationEvent: (event: RyftValidationChangeEvent | null) => void;
  initiateCheckoutPaymentSession: (
    parameters: Omit<RyftPaymentInitiateRequestType, "returnUrl">,
  ) => Promise<SafeReturnType<{ clientSecret: string }>>;
  initiateOrderPaymentSession: (parameters: {
    orderId: number;
  }) => Promise<SafeReturnType<RyftOrderPaymentInitiateResponseType>>;
  updatePaymentSession: (
    parameters: RyftPaymentUpdatePathParametersType &
      RyftPaymentUpdateRequestType,
  ) => Promise<SafeReturnType<{ id: string }>>;
  payWithRyft: () => Promise<SafeReturnType<RyftPaymentAttemptResponse>>;
};

export const RyftCardPaymentContext =
  createContext<RyftCardPaymentContextType | null>(null);
